<template>
    <div class="page-main">
        <div class='bottomdiv'>
            <p>这是底部</p>
        </div>
        <!-- <img :src="base64" class="img-template">
        <div class='imgtemplate' ref='imgTemplate'>
            <div class='divwrap'>
                <p>这是要保存的模板</p>
                <p>{{userInfo.nickName}}</p>
                <img src="http://pics.sdoprofile.com/group1/M00/01/37/Cva3DV4IZIyAVRv4AAsnfRLim90380_L.jpg?size=384x749" alt="">
            </div>
        </div> -->
        <button class="copycodezhong" @click='copycodezhong'  :data-clipboard-text='scheme'>一键复制文案(zhong)</button>
        <button class="copybtn" @click='copycode'  :data-clipboard-text='schemeasd'>一键复制文案(ying)</button>
    </div>
</template>

<script>
// import html2canvas from 'html2canvas';
import Clipboard from 'clipboard';

export default {
    components: {
    },
    data() {
        return {
            base64: ''
        };
    },
    computed: {
        scheme() {
            return '就差你了，帮我一下，我的手机壳就可以一元购买了。或者【复 制】整条信息，下载文物加APP并打开，就可以帮我啦！2名好友助力成功，团长即可一元定制手机壳=（型号可选）';
        },
        schemeasd() {
            return '就差你了,帮我一下,我的手机壳就可以一元购买了.或者[复 制]整条信息,下载文物加APP并打开,就可以帮我啦!2名好友助力成功,团长即可一元定制手机壳=(型号可选)'
        }
    },
    mounted() {
        // html2canvas(this.$refs.imgTemplate, {
        //     scale: 3,
        //     logging: false,
        //     useCORS: true
        // }).then(c => {
        //     this.base64 = c.toDataURL('image/png', 1);
        // });
    },
    methods: {
        copycode() {
            /* eslint-disable-next-line */
            document.body.style.overflow = 'hidden';
            const clipboard = new Clipboard('.copybtn');
            this.$toastMessage('复制成功！');
            clipboard.on('success', () => {
                console.log('复制成功');
                clipboard.destroy();
            });
            clipboard.on('error', () => {
                console.log('复制失败');
                clipboard.destroy();
            });
        },
        copycodezhong() {
            /* eslint-disable-next-line */
            document.body.style.overflow = 'hidden';
            const clipboard = new Clipboard('.copycodezhong');
            this.$toastMessage('复制成功！');
            clipboard.on('success', () => {
                console.log('复制成功');
                clipboard.destroy();
            });
            clipboard.on('error', () => {
                console.log('复制失败');
                clipboard.destroy();
            });
        }
    }
};
</script>

<style lang='stylus' scoped>
.page-main
    width 100%
    height 100%
    position relative
    .bottomdiv
        width 100%
        height 100%
        background-color green
    .img-template
        position fixed
        top 0
        left 0
        opacity 0
        z-index 5
    .imgtemplate
        width 750px
        height 1334px
        background-color transparent
        position fixed
        top 100rem
        left 0
        display flex
        flex-direction row
        align-items center
        justify-content center
        .divwrap
            width 400px
            height 400px
            display flex
            flex-direction row
            align-items center
            justify-content center
</style>
